(() => {
  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

  const initDesktopImageCarousel = (section) => {
    const track = section.querySelector('[data-carousel-track]');
    const slides = Array.from(section.querySelectorAll('[data-carousel-slide]'));
    const prev = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    const dotsWrap = section.querySelector('[data-carousel-dots]');

    if (!track || slides.length === 0) return;

    const autoplay = section.dataset.autoplay === 'true';
    const loop = section.dataset.loop === 'true';
    const speed = Number(section.dataset.speed || 3500);

    let index = 0;
    let timer = null;
    let dots = [];

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const update = () => {
      if (isMobile()) {
        track.style.transform = '';
        stop();
        return;
      }

      track.style.transform = `translate3d(${-index * 100}%, 0, 0)`;

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    };

    const goTo = (nextIndex) => {
      if (loop) {
        index = (nextIndex + slides.length) % slides.length;
      } else {
        index = Math.max(0, Math.min(nextIndex, slides.length - 1));
      }

      update();
    };

    const start = () => {
      if (isMobile() || !autoplay || slides.length < 2) return;

      stop();

      timer = window.setInterval(() => {
        goTo(index + 1);
      }, speed);
    };

    const restart = () => {
      stop();
      start();
    };

    if (dotsWrap) {
      dotsWrap.innerHTML = '';

      slides.forEach((_, slideIndex) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'custom-carousel-products__dot';
        dot.setAttribute('aria-label', `Go to slide ${slideIndex + 1}`);

        dot.addEventListener('click', () => {
          goTo(slideIndex);
          restart();
        });

        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    prev?.addEventListener('click', () => {
      goTo(index - 1);
      restart();
    });

    next?.addEventListener('click', () => {
      goTo(index + 1);
      restart();
    });

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);

    window.addEventListener('resize', () => {
      update();
      restart();
    });

    update();
    start();
  };

  const initMobileProductCarousel = (section) => {
    const track = section.querySelector('[data-mobile-products-track]');
    const prev = section.querySelector('[data-mobile-products-prev]');
    const next = section.querySelector('[data-mobile-products-next]');

    if (!track || !prev || !next) return;

    const slides = Array.from(track.children);
    const total = slides.length;

    let index = 0;

    const update = () => {
      if (!isMobile()) return;

      track.scrollTo({
        left: index * track.clientWidth,
        behavior: 'smooth'
      });
    };

    const goNext = () => {
      index += 1;

      if (index >= total) {
        index = 0;
      }

      update();
    };

    const goPrev = () => {
      index -= 1;

      if (index < 0) {
        index = total - 1;
      }

      update();
    };

    next.addEventListener('click', goNext);
    prev.addEventListener('click', goPrev);

    window.addEventListener('resize', update);
  };

  const initSection = (section) => {
    initDesktopImageCarousel(section);
    initMobileProductCarousel(section);
  };

  const initAll = () => {
    document
      .querySelectorAll('[data-custom-carousel-products]')
      .forEach(initSection);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-custom-carousel-products]');
    if (section) initSection(section);
  });
})();